module.exports = __webpack_public_path__ + "img/tips-mountain-icon.2ddda965.svg";